angular.module('gc.ws', [])
  .service('WS', ['$rootScope', 'WS_URL', function($rootScope, WS_URL) {
    return {

      create: function(onMsg, onOpen) {
        console.debug('WS connect');

        var ws = new WebSocket(WS_URL);

        ws.onerror = function(err) {
          console.error('WS error', err);
        };

        ws.onclose = function(event) {
          console.debug('WS close', event.code, event.reason, event.wasClean);
          // auto reconnect
          clearTimeout(this.reconnectTimeout);
          this.reconnectTimeout = setTimeout(function() {
            this.create(onMsg, onOpen);
          }.bind(this), 5000);
        }.bind(this);

        ws.onmessage = function(event) {
          try {

            if(typeof event.data ==='string' && event.data === 'ping') {
              ws.send('pong');
              return;
            }
            
            var json = JSON.parse(event.data)
          } catch (e) {
            console.error('unable to parse WS event', event.data);
            return;
          }

          onMsg(json);
        }.bind(this);

        ws.onopen = onOpen;

        return ws;
      },

    };
}]);
